import { Component, Inject, OnInit } from '@angular/core';
import { SortTopicsService } from "../sort-topics/sort-topics.service";
import { Router } from '@angular/router';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
@Component({
	selector: 'app-add-new-topics',
	templateUrl: './add-new-topics.component.html',
	styleUrls: ['./add-new-topics.component.scss']
})
export class AddNewTopicsComponent implements OnInit {
	openOptions: Boolean = false;
	fieldTitle = "";
	fieldType = "";
	fieldSms = [];
	fieldEmail = [];
	fieldSubtopics = [];

	openOptionSetting(fieldType) {
		this.fieldType = fieldType;
		this.openOptions = true;

	};

	constructor(
		private dialogRef: MatDialogRef<AddNewTopicsComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any,
		private _sortTopicsService: SortTopicsService,
		private _router: Router
	) { }

	ngOnInit(): void {
		let option = "";
		this.fieldSms.push(option);
		this.fieldEmail.push(option);
		this.fieldSubtopics.push(option);

		if (this.data['_id']) {
			this.fieldTitle = this.data['name'];
			if (this.data['sms'] && this.data['sms'].length > 0) {
				this.fieldSms = this.data['sms'];
			}
			if (this.data['emails'] && this.data['emails'].length > 0) {
				this.fieldEmail = this.data['emails'];
			}
			if (this.data['sub_topics'] && this.data['sub_topics'].length > 0) {
				this.fieldSubtopics = this.data['sub_topics'];
			}
		}
	}

	addTopic() {

		var topic = {
			organization: localStorage.getItem('organization'),
			name: this.fieldTitle,
			sub_topics: this.fieldSubtopics.filter(function (e) { return e }),
			emails: this.fieldEmail.filter(function (e) { return e }),
			sms: this.fieldSms.filter(function (e) { return e })
		}
		this._sortTopicsService.createTopic(topic).subscribe((response) => {
			if (response['success']) {
				this.dialogRef.close();
			}
		});
	}

	editTopic() {

		var topic = {
			_id: this.data['_id'],
			name: this.fieldTitle,
			sub_topics: this.fieldSubtopics.length > 0 ? this.fieldSubtopics.filter(function (e) { return e }) : [],
			emails: this.fieldEmail.length > 0 ? this.fieldEmail.filter(function (e) { return e }) : [],
			sms: this.fieldSms.length > 0 ? this.fieldSms.filter(function (e) { return e }) : []
		}
		this._sortTopicsService.updateTopic(topic).subscribe((response) => {
			if (response['success']) {
				this.dialogRef.close();
			}
		});
	}

	optionValueChange(index, type, value): void {
		if (type === 'subtopics') {
			this.fieldSubtopics[index] = value;
		} else if (type === 'emails') {
			this.fieldEmail[index] = value;
		} else if (type === 'sms') {
			this.fieldSms[index] = value;
		}
	}

	addSubtopics(): void {
		this.fieldSubtopics.push("");
	}
	addEmail(): void {
		this.fieldEmail.push("");
	}
	addNewsms(): void {
		this.fieldSms.push("");
	}
}
